export enum MyOrderChildrenPathEnum {
	OrderDetail = ':id',
	MyOrdersListing = '',
}
